export default {
  welcome: 'Welcome',
};
